import * as React from 'react';

import { GetProductViewQuery } from '@notino/shared/definitions/types';

import { dispatchTrackingEvent } from '@context/tracking/utils';

export const useTrackPageView = (
  variant: GetProductViewQuery['productDetailByMasterId'][number]['variants'][number]
) => {
  React.useEffect(() => {
    dispatchTrackingEvent({
      event: 'page_view',
      page: {
        path: window.location.pathname,
        title: variant.seo.title,
        type: 'product',
        unified_name: `product-${variant.productCode}`,
      },
      _clear: true,
    });
  }, [variant.productCode, variant.seo.title]);
};
